/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Home_RoleInputs */

const en_home_role = /** @type {(inputs: Home_RoleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.role}`)
};

const id_home_role = /** @type {(inputs: Home_RoleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`peran ${i?.role}`)
};

/**
* | output |
* | --- |
* | "{role}" |
*
* @param {Home_RoleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const home_role = /** @type {((inputs: Home_RoleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_RoleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_role(inputs)
	return en_home_role(inputs)
});